import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { LOGIN_AUTH } from './types';
import { notify } from '../services/notification'
import getHeadersformdata from './getHeaderFormdata'



export const MsrAction = (params = {}) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + Url.CREATE_MSR
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  try {
    const response = await axios(options);
    if (response.status === 200 || response.status === 201) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    if (error.response) {
      if (error.response.status === 400) {
        const errorData = error.response.data.error;
        if (errorData) {
          if (errorData.mobile_number) {
            notify.error(errorData.mobile_number[0]);
          }
          if (errorData.msr_id) {
            notify.error(errorData.msr_id);
          }
          if (!errorData.mobile_number && !errorData.msr_id) {
            notify.error(errorData);
          }
        }
        return error.response;
      } else {
        errorHandler(error);
      }
    } else {
      errorHandler(error);
    }
  }
};
  
export const MsrListAction = (page, page_size, query) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.MSR_NAMES_LIST + `?page_size=${page_size}&page=${page}${query ? query  : ""}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_MSR_NAME_LIST, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
    });
};

  export const MsrIsActiveViewAction = (params = {}, id) => dispatch => {
    const url =`${process.env.REACT_APP_API_URL}${Url.ACTIVE_MSR}/${id}`
    let options = Object.assign({ method: 'PUT' }, params ? { data: params } : null)
    options.headers = getHeadersformdata()
    options.url = url
    return axios(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.PUT_ACTIVE_MSR, payload: resp })
        return resp
      } else { return null }
    }).catch(error => {
      if (error?.response?.status === 400) {
        const errorMessage = error.response.data.msg;
        if(errorMessage){
          notify.error(errorMessage);
        }else{
          errorHandler(error)
        }
      }
    })
  }

  export const UpdateMsrAction = (params = {}, id) => dispatch => {
    const url =`${process.env.REACT_APP_API_URL}${Url.UPDATE_MSR}/${id}/edit`
    let options = Object.assign({ method: 'PUT' }, params ? { data: params } : null);
    options.headers = getHeaders();
    options.url = url;
    
    return axios(options)
      .then(resp => {
        if (resp.status === 200 || resp.status === 201) {
          return resp;
        } else {
          return null;
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          const responseData = error.response.data;
          if (responseData.error) {
            notify.error(responseData.error);
          }
          if (responseData.errors && responseData.errors.email) {
            notify.error(responseData.errors.email);
          }
          if (responseData.errors && responseData.errors.mobile_number) {
            notify.error(responseData.errors.mobile_number[0]);
          }
          return error.response;
        }
        errorHandler(error);
        return error.response; 
      });
  };

  export const MsrNameAction = (id) => dispatch => {
    const url =`${process.env.REACT_APP_API_URL}${Url.MSR_NAMES}/${id}`
    let options = Object.assign({ method: 'GET' })
    options.headers = getHeaders()
    options.url = url
    return axios(options).then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_MSR_NAME, payload: response })
        return response
      } else { return null }
    })
      .catch(error => {
        errorHandler(error)
      })
  }

  export const dowloadmsrlistAction = (page, page_size, query) => async (dispatch) => {
    const url = process.env.REACT_APP_API_URL + Url.MSR_LIST_EXCEL + `?page_size=${page_size}&page=${page}${query ? query  : ""}`;
    const headers = getHeaders();
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers,
      });
  
      if (response.status === 200) {
        return response.blob();
      } else {
        notify.error('Failed to download file');
        return null
      }
    } catch (error) {
      errorHandler(error)
    }
  };